module.exports = __webpack_public_path__ + "static/media/CircularPro-BookItalic.26c5fdb8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-BookItalic.eot
// module id = 113
// module chunks = 0